<template>
    <div style="height: 100%">
        <b-tabs id="tabsRsaAccettazioneEdit" ref="tabsRsaAccettazioneEdit" v-model="activeTabIndex"
            nav-wrapper-class="sa-tab-items" content-class="mt-3" class="sa-tab"
            style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
            <b-tab title="Anagrafica">
                <div class="sa-tab-scrol">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-card class="sa-card sa-card-border" header="Struttura - Presidio" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label>Struttura<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.codiceStruttura" class="mb-2 mr-sm-2 mb-sm-0"
                                            :value="null" value-field="codiceStruttura" text-field="denominazione"
                                            :options="strutturaOptions" @change="onChangeStruttura"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label>Presidi<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.idPresidio"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="id"
                                            text-field="denominazione" :options="presidiOptions"
                                            @change="onChangePresidio"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label>Regime<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.regime"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="''" value-field="codice"
                                            text-field="descrizione" :options="regimiOptions"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label>{{ getLabelTraduora("nurity.accettazione.setting") }}</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.settingCodice" class="mb-2 mr-sm-2 mb-sm-0" :value="''"
                                            value-field="codice" text-field="setting" :options="settingsPresidiOptions"
                                            @change="onChangeSettingCodice">
                                            <template #first>
                                                <b-form-select-option :value="null"
                                                    disabled>Seleziona</b-form-select-option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label>Livello</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.idSettingLivello" class="mb-2 mr-sm-2 mb-sm-0" :value="''"
                                            value-field="id" text-field="descrizione" :options="settingLivelliOptions"
                                            @change="onChangeRsaSettingLivelli"> </b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Data Segnalazione</label>
                                        <date-picker format="DD/MM/YYYY HH:mm" value-type="timestamp"
                                            v-model="jsonData.dataSegnalazione" type="datetime"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Data Accettazione</label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp"
                                            v-model="jsonData.dataAccettazione" type="date"
                                            :disabled="jsonData.statoAttuale == null"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data" v-if="jsonData.statoAttuale === 'RICOVERATO'">Data
                                            Ricovero / Presa in carico</label>
                                        <label class="sa-label-data" v-else>Data Arruolamento</label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp"
                                            v-model="jsonData.dataRicovero" type="date"
                                            :disabled="jsonData.dataRicovero == null"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Data Dimissione</label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp"
                                            v-model="jsonData.dataDimissioneTrasferimento" type="date"
                                            :disabled="true"></date-picker>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-card class="sa-card sa-card-border" header="Anagrafica" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Tipo Identificativo</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.tipoIdentificativo"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="tipiIdentificativoOptions"
                                            :value="null" value-field="codice" text-field="descrizione" required
                                            disabled></b-form-select>
                                    </b-col>
                                    <b-col v-if="anagraficaRicerca" cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Codice Fiscale/STP/ENI*</label>
                                        <b-input-group class="mb-3">
                                            <b-form-input maxlength="16" class="text-uppercase"
                                                v-model="jsonData.accettazioneAnagrafica.identificativo"
                                                @keypress="onKeyPress" :readonly="isCheckIdentificativo"></b-form-input>
                                            <b-button size="sm" variant="" :disabled="isCheckIdentificativo"
                                                @click="onSearchAnagraficaClick"><b-icon
                                                    icon="search"></b-icon></b-button>
                                        </b-input-group>
                                    </b-col>
                                    <b-col v-else cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data"> {{ this.$i18n.t("patients.lblFiscalCode") }}<span
                                                style="color: red">*</span> </label>
                                        <b-input-group class="mb-3">
                                            <!-- <b-form-input maxlength="16" class="text-uppercase" v-model="data.codiceFiscale" @keypress="onKeyPress"></b-form-input> -->
                                            <b-form-input maxlength="16" class="text-uppercase"
                                                v-model="jsonData.accettazioneAnagrafica.identificativo"
                                                :disabled="isCheckIdentificativo"></b-form-input>
                                            <!-- <b-button size="sm" variant="" @click="onClick"> <b-icon icon="search"></b-icon> </b-button> -->
                                            <b-button size="sm" variant="" :disabled="isCheckIdentificativo"
                                                v-b-tooltip.hover title="Check Codice Fiscale"
                                                @click="onClickCodiceFiscale(jsonData.accettazioneAnagrafica.identificativo)"><b-icon
                                                    icon="search"></b-icon></b-button>
                                        </b-input-group>
                                    </b-col>
                                    <!-- <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label htmlFor="rsaGestioneOspitiEditComponentAccettazioneAnagraficaIdentificativo" class="sa-label-data">Codice Fiscale/STP/ENI*</label>
                                        <b-form-input id="rsaGestioneOspitiEditComponentOspiteIdentificativo" v-model="jsonData.accettazioneAnagrafica.identificativo"></b-form-input>
                                    </b-col> -->
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Cognome<span style="color: red">*</span></label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.cognome"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Nome
                                            <span style="color: red">*</span>
                                        </label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.nome"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Data di nascita<span
                                                style="color: red">*</span></label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp"
                                            v-model="jsonData.accettazioneAnagrafica.dataNascita"
                                            type="date"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Provincia di nascita<span
                                                style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.provinciaNascita"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="provinceNascitaOptions" :value="null"
                                            value-field="sigla" text-field="provincia"
                                            @change="onChangeProvinciaNascita" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Comune di nascita<span
                                                style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat"
                                            text-field="comune" :options="comuniNascitaOptions"
                                            @change="onChangeComuneNascita" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Sesso<span style="color: red">*</span></label>
                                        <b-form-select v-model="jsonData.accettazioneAnagrafica.sesso"
                                            :options="sessoOptions"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Numero di Telefono</label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.telefono"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">E-Mail</label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.email"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <b-card class="sa-card sa-card-border" header="Residenza" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Regione<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.regioneResidenza"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat"
                                            text-field="regione" :options="regioniResidenzaOptions"
                                            @change="onChangeRegioneResidenza" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Provincia<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.provinciaResidenza"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="sigla"
                                            text-field="provincia" :options="provinceResidenzaOptions"
                                            @change="onChangeProvinciaResidenza" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Comune<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat"
                                            text-field="comune" :options="comuniResidenzaOptions"
                                            @change="onChangeComuneResidenza" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">CAP<span style="color: red">*</span></label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.capResidenza"
                                            @input="onInputCapResidenza"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <label class="sa-label-data">Indirizzo<span style="color: red">*</span></label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.indirizzoResidenza"
                                            @input="onInputIndirizzoResidenza"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <b-card class="sa-card sa-card-border" header="Domicilio" header-tag="header"
                                footer-tag="footer" title="">
                                <template #header>
                                    <div style="display: flex">
                                        <span style="flex: 1">Domicilio</span>
                                        <b-form-checkbox v-model="isDomicilioUgualeResidenza" name="check-button"
                                            switch>Coincide con residenza</b-form-checkbox>
                                    </div>
                                </template>
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Regione<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref" class="mb-2 mr-sm-2 mb-sm-0"
                                            v-model="jsonData.accettazioneAnagrafica.regioneDomicilio" :value="null"
                                            value-field="codiceIstat" text-field="regione"
                                            :options="regioniDomicilioOptions" @input="onInputRegioniDomicilio" required
                                            :disabled="isDomicilioUgualeResidenza"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Provincia<span style="color: red">*</span></label>

                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.provinciaDomicilio"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="provinceDomicilioOptions"
                                            :value="null" value-field="sigla" text-field="provincia"
                                            @input="onInputProvinciaDomicilio" required
                                            :disabled="isDomicilioUgualeResidenza"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Comune<span style="color: red">*</span></label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat"
                                            class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="codiceIstat"
                                            text-field="comune" :options="comuniDomicilioOptions"
                                            @input="onInputComuneDomicilio" required
                                            :disabled="isDomicilioUgualeResidenza"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">CAP<span style="color: red">*</span></label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.capDomicilio"
                                            :disabled="isDomicilioUgualeResidenza"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <label class="sa-label-data">Indirizzo<span style="color: red">*</span></label>
                                        <b-form-input v-model="jsonData.accettazioneAnagrafica.indirizzoDomicilio"
                                            :disabled="isDomicilioUgualeResidenza"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <b-card class="sa-card sa-card-border" header="ASL di residenza" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Codice A.S.L.</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioniAsl.aslResidenzaCodice"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">A.S.L.</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioniAsl.aslResidenzaDenominazione"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Ambito</label>
                                        <!--   <b-form-input v-model="jsonData.accettazioniAsl.aslResidenzaAmbito"></b-form-input> -->
                                        <b-form-select v-model="jsonData.accettazioniAsl.aslResidenzaAmbito"
                                            :options="ambitiAslResidenzaOptions" text-field="text"
                                            value-field="value"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Distretto</label>
                                        <b-form-select v-model="jsonData.accettazioniAsl.aslResidenzaDistretto"
                                            :options="distrettiAslResidenzaOptions" value-field="codiceDistretto"
                                            text-field="descrizione"></b-form-select>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                        <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                            <b-card class="sa-card sa-card-border" header="ASL di domicilio" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Codice A.S.L.</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioniAsl.aslDomicilioCodice"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">A.S.L.</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioniAsl.aslDomicilioDenominazione"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Ambito</label>
                                        <!--    <b-form-input v-model="jsonData.accettazioniAsl.aslDomicilioAmbito"></b-form-input> -->
                                        <b-form-select v-model="jsonData.accettazioniAsl.aslDomicilioAmbito"
                                            :options="ambitiAslDomicilioOptions" text-field="text"
                                            value-field="value"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Distretto</label>
                                        <b-form-select v-model="jsonData.accettazioniAsl.aslDomicilioDistretto"
                                            :options="distrettiAslDomicilioOptions" value-field="codiceDistretto"
                                            text-field="descrizione"></b-form-select>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-card class="sa-card sa-card-border" header="Altre info" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Provenienza Richiesta</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.provenienzaRichiesta"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="provenienzaRichiestaOptions"
                                            :value="null" value-field="codice" text-field="descrizione" required
                                            @change="onChangeProvenienzaRichiesta"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Struttura di Provenienza</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.strutturaProvenienza"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="strutturaProvenienzaOptions"
                                            :value="null" value-field="codice" text-field="descrizione"
                                            @change="onChangeStrutturaProvenienza" required
                                            :disabled="!isProvienzaRichiestaDisable"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Unità operativa / Reparto</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.codiceStrutturaProvenienzaReparto"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="strutturaProvenienzaRepartiOptions"
                                            :value="null" value-field="codiceReparto" text-field="descrizioneReparto"
                                            required :disabled="!isProvienzaRichiestaDisable"
                                            @change="onChangeStrutturaProvenienzaReparto"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Medico Inviante</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioneAnagrafica.medicoInviante"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Provenienza ospite</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.provenienzaPaziente"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="provenienzaPazienteOptions"
                                            :value="null" value-field="codice" text-field="descrizione"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Tipologia Ospite</label>
                                        <b-form-select id="inline-form-custom-select-pref"
                                            v-model="jsonData.accettazioneAnagrafica.tipologiaPaziente"
                                            class="mb-2 mr-sm-2 mb-sm-0" :options="tipologiaPazienteOptions"
                                            :value="null" value-field="codice" text-field="descrizione"></b-form-select>
                                    </b-col>
                                    <!--  <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">Scadenza Domicilio Sanitario</label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataScadenzaDomicilioSanitario" type="date"></date-picker>
                                    </b-col> -->
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">MMG/PLS</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioneAnagrafica.medicoCurante"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">MMG/PLS Telefono</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioneAnagrafica.medicoCuranteTelefono"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                        <label class="sa-label-data">MMG/PLS E-Mail</label>
                                        <b-form-input
                                            v-model="jsonData.accettazioneAnagrafica.emailMedicoCurante"></b-form-input>
                                    </b-col>
                                    <!--  <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Non Autonomo</label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.nonAutonomo" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="nonAutonomoOptions"></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Decreto Invalidità</label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.decretoInvalidita" class="mb-2 mr-sm-2 mb-sm-0" :value="null" value-field="value" text-field="text" :options="decretoInvaliditaOptions"></b-form-select>
                                    </b-col>
                                                                       <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Titolo di Studio</label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.titoloStudio" class="mb-2 mr-sm-2 mb-sm-0" :options="titoloStudioOptions" :value="null" value-field="codice" text-field="descrizione" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Tipo Documento</label>
                                        <b-form-select id="inline-form-custom-select-pref" v-model="jsonData.documentoTipo" class="mb-2 mr-sm-2 mb-sm-0" :options="tipoDocumentoOptions" :value="null" value-field="codice" text-field="descrizione" required></b-form-select>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Numero Documento</label>
                                        <b-form-input v-model="jsonData.documentoNumero"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Data Rilascio</label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.documentoDataRilascio" type="date"></date-picker>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                        <label class="sa-label-data">Data Scadenza</label>
                                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.documentoDataScadenza" type="date"></date-picker>
                                    </b-col> -->
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <b-card class="sa-card sa-card-border" header="Diagnosi e Note" header-tag="header"
                                footer-tag="footer" title="">
                                <b-row>
                                    <!-- <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Diagnosi (ICD-9)</label>
                    <diagnosi-icdIx-component></diagnosi-icdIx-component>
                  </b-col> -->
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <b-input-group class="mb-3">
                                            <label class="sa-label-data">Diagnosi in Ingresso</label>
                                            <b-button variant="" @click="onClickSearchIcdix"><b-icon icon="search">
                                                </b-icon></b-button>
                                        </b-input-group>
                                        <b-form-textarea v-model="jsonData.diagnosiIngresso" placeholder=""
                                            rows="7"></b-form-textarea>
                                    </b-col>
                                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <label class="sa-label-data">Note</label>
                                        <b-form-textarea v-model="jsonData.accettazioneAnagrafica.note"
                                            id="textarea-auto-height" placeholder="" rows="7"
                                            style="margin-top: 12px"></b-form-textarea>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-col>
                    </b-row>
                    <diagnosi-icd-ix-component v-show="false" ref="cmpDiagnosiIcdIx"
                        @onModalClose="modalClose"></diagnosi-icd-ix-component>
                </div>
            </b-tab>
            <b-tab v-if="jsonData.regime === 'AMBULATORIALE'" id="tbRsaSchedaPaziente" title="Scheda Paziente"
                :disabled="isTabDisabled">
                <rsa-scheda-paziente-edit-component ref="cmpRsaSchedaPazienteEdit"></rsa-scheda-paziente-edit-component>
            </b-tab>
            <b-tab id="tbRsaPersoneRiferimento" title="Persona di Riferimento" :disabled="isTabDisabled">
                <rsa-persona-riferimento-component ref="RsaPersonaRiferimentoComponent"
                    :jsonData="jsonData"></rsa-persona-riferimento-component>
                <!-- <rsa-persona-riferimento-component ref="RsaPersonaRiferimentoComponent" @updateListaFamiliari="onUpdateListaFamiliari"></rsa-persona-riferimento-component> -->
            </b-tab>
            <b-tab id="tbRsaImpegnativa" title="Impegnativa (U.V.I.)" v-if="tbRsaImpegnativa" :disabled="isTabDisabled">
                <rsa-accettazione-impegnativa-list-component ref="cmpRsaAccettazioneImpegnativaList"
                    :idAccettazione="id" :jsonData="jsonData" :isViewMode="false" />
            </b-tab>
            <b-tab id="tbSpesaExtra" title="Spese Extra" :disabled="isTabDisabled">
                <rsa-spesa-extra-list-component :jsonDataAccettazione="jsonData"
                    ref="cmpRsaSpesaExtraListComponent"></rsa-spesa-extra-list-component>
            </b-tab>

            <b-tab id="tbValutazioneIngresso" title="Valutazione All'Ingresso" :disabled="isTabDisabled">
                <rsa-paziente-valutazione-ingresso-list-component
                    ref="cmpRsaPazienteValutazioneIngresso"></rsa-paziente-valutazione-ingresso-list-component>
            </b-tab>

            <b-tab id="tbRsaRicette" title="Ricette" v-if="tbRsaRicette" :disabled="isTabDisabled">
                <rsa-accettazione-ricette-list-component ref="RsaAccettazioneRicetteListComponent" :idAccettazione="id"
                    :jsonData="jsonData"></rsa-accettazione-ricette-list-component>
            </b-tab>

            <b-tab id="tbRsaEsenzioni" title="Esenzioni" v-if="tbRsaEsenzioni" :disabled="isTabDisabled">
                <!-- <rsa-esenzioni-component @onModalClose="onModalClose"></rsa-esenzioni-component> -->
            </b-tab>

            <b-tab id="tbSchedeValutazione" title="Scale Valutazione" :disabled="isTabDisabled"
                v-if="tbRsaScaleValutazione">
                <rsa-accettazione-schede-valutazione-component
                    ref="RsaAccettazioneSchedeValutazioneComponent"></rsa-accettazione-schede-valutazione-component>
            </b-tab>

            <b-tab id="tbDatiFatturazione" title="Dati di Fatturazione" v-if="tbDatiFatturazione"
                :disabled="isTabDisabled">
                <rsa-accettazione-dati-fatturazione-list-component
                    ref="cmpRsaAccettazioneDatiFatturazioneComponent"></rsa-accettazione-dati-fatturazione-list-component>
            </b-tab>
            <b-tab id="tbConsensi" title="Consensi" :disabled="isTabDisabled">
                <accettazione-consensi-list-component
                    ref="cmpRsaAccettazioneConsensiList"></accettazione-consensi-list-component>
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import axios from "axios";
import "vue2-datepicker/index.css";
import DatePicker from "vue2-datepicker";
import RsaPersonaRiferimentoComponent from "../../components/RsaPersonaRiferimentoComponent.vue";
import DiagnosiIcdIxComponent from "../../../utility/components/DiagnosiIcdIxComponent.vue";
import RsaAccettazioneSchedeValutazioneComponent from "./RsaAccettazioneSchedeValutazioneComponent.vue";
import RsaAccettazioneRicetteListComponent from "./RsaAccettazioneRicetteListComponent.vue";
import RsaAccettazioneImpegnativaListComponent from "./RsaAccettazioneImpegnativaListComponent.vue";
import RsaAccettazioneDatiFatturazioneListComponent from "./RsaAccettazioneDatiFatturazioneListComponent.vue";
import RsaSpesaExtraListComponent from "./RsaSpesaExtraListComponent.vue";
import moment from "moment";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneConsensiListComponent from "../../../accettazione/components/AccettazioneConsensiListComponent.vue";
import RsaPazienteValutazioneIngressoListComponent from "../../rsapaziente/components/RsaPazienteValutazioneIngressoListComponent.vue";
import RsaSchedaPazienteEditComponent from "./RsaSchedaPazienteEditComponent.vue";
export default {
    props: {
        // id: { type: String },
    },
    components: {
        DatePicker,
        RsaSpesaExtraListComponent,
        RsaPersonaRiferimentoComponent,
        DiagnosiIcdIxComponent,
        RsaAccettazioneSchedeValutazioneComponent,
        RsaAccettazioneRicetteListComponent,
        RsaAccettazioneImpegnativaListComponent,
        RsaAccettazioneDatiFatturazioneListComponent,
        AccettazioneConsensiListComponent,
        RsaPazienteValutazioneIngressoListComponent,
        RsaSchedaPazienteEditComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsaaccettazioni",
            pathResourceRegimi: "/accettazioneregimi",
            pathResourceStrutture: "/strutture",
            pathResourcePresidi: "/strutturepresidi",
            pathResourceProvince: "/province",
            pathResourceComuni: "/comuni/provincia",
            pathResourceRegioni: "/regioni",
            pathResourceComune: "/comuni/istat",
            pathResourceAsl: "/asl/comune",
            pathResourceIdentificativo: "/anagraficaidentificativo",
            pathResourceSettingsPresidi: "/rsasettingspresidi",
            pathResourceTitoliStudio: "/rsatitolistudio",
            pathResourceAmbiti: "/serviziambiticomuni",
            pathResourceDistretti: "/servizidistretticomuni",
            pathResourceTipologiaPaziente: "/accettazioneanagraficatipologiapaziente",
            pathResourceProvenienzaPaziente: "/accettazioneanagraficaprovenienzapaziente",
            pathResourceRsaSettingLivelli: "/rsasettinglivelli",
            pathResourceProvenienzaRichiesta: "/rsaprovenienzarichiesta",
            pathResourceStrutturaProvenienzaReparti: "/rsastruttureprovenienzareparti",
            pathResourceStruttureProvienza: "/rsastruttureprovenienza",
            anagraficaRicerca: false,
            isDomicilioUgualeResidenza: false,
            isCheckIdentificativo: false,
            tbRsaScaleValutazione: false,
            filtro: { regione: null },
            strutturaOptions: [{ codiceStruttura: null, denominazione: "- Seleziona Struttura -" }],
            presidiOptions: [{ id: null, denominazione: "-Seleziona Presidio-" }],
            regimiOptions: [],
            isViewMode: false,
            regioniResidenzaOptions: [],
            regioniDomicilioOptions: [],
            provinceNascitaOptions: [],
            provenienzaPazienteOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            provenienzaRichiestaOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            strutturaProvenienzaOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            strutturaProvenienzaRepartiOptions: [{ codiceReparto: null, descrizioneReparto: "-Seleziona Valore-" }],
            tipologiaPazienteOptions: [{ codice: null, descrizione: "-Seleziona Valore-" }],
            provinceResidenzaOptions: [{ codice: null, provincia: "-Seleziona Provincia-" }],
            provinceDomicilioOptions: [{ codice: null, provincia: "-Seleziona Provincia-" }],
            comuniResidenzaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            comuniDomicilioOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            comuniNascitaOptions: [{ codiceIstat: null, comune: "-Seleziona Comune-" }],
            tipiIdentificativoOptions: [{ codice: null, descrizione: "-Seleziona Tipo Identificativo-" }],
            tipoDocumentoOptions: [],
            settingsPresidiOptions: [{ codice: null, setting: "-Seleziona " + this.getLabelTraduora("nurity.accettazione.setting") + "-" }],
            ambitiAslDomicilioOptions: [{ text: "- Seleziona Valore -", value: null }],
            ambitiAslResidenzaOptions: [{ text: "- Seleziona Valore -", value: null }],
            distrettiAslDomicilioOptions: [{ descrizione: "- Seleziona Valore -", codiceDistretto: null }],
            distrettiAslResidenzaOptions: [{ descrizione: "- Seleziona Valore -", codiceDistretto: null }],
            activeTabIndex: 0,
            isTabDisabled: null,
            tbDatiFatturazione: true,
            tbRsaRicette: false,
            tbRsaImpegnativa: true,
            tbRsaEsenzioni: false,
            tbValutazioneIngresso: false,
            anagraficaInfo: {},
            codiceFiscaleValido: false,
            id: null,
            // settings: null,
            isProvienzaRichiestaDisable: false,
            jsonData: {
                codiceStruttura: null, //non a video
                idPresidio: null, //non a video
                numero: "", //non a video
                note: null, //non a video
                regime: null, //non a video
                settingCodice: null,
                settingDescrizione: "",
                idPrenotazione: null, //non a video
                idSettingLivello: null,
                /* nonAutonomo: null, */
                /* decretoInvalidita: null,
                strutturaProvenienza: null,
                titoloStudio: null,
                documentoTipo: null,
                documentoNumero: "",
                documentoDataRilascio: null,
                documentoDataScadenza: null, */
                accettazioneStruttura: {}, //non a video
                accettazioneAnagrafica: {
                    idAccettazione: null, //non a video
                    tipo: null, //non a video
                    identificativo: null,
                    tipoIdentificativo: "CF", //non a video
                    cognome: null,
                    nome: null,
                    dataNascita: null,
                    provinciaNascita: null,
                    comuneNascitaCodiceIstat: null,
                    sesso: null,
                    regioneResidenza: null,
                    provinciaResidenza: null,
                    comuneResidenzaCodiceIstat: null,
                    indirizzoResidenza: null,
                    capResidenza: null,
                    regioneDomicilio: null,
                    provinciaDomicilio: null,
                    comuneDomicilioCodiceIstat: null,
                    indirizzoDomicilio: null,
                    capDomicilio: null,
                    note: null,
                    medicoCurante: "",
                    codiceFiscaleMedicoCurante: null, //non a video
                    telefono: "",
                    email: "",
                    emailMedicoCurante: "",
                    medicoCuranteTelefono: "",
                    provenienzaPaziente: null,
                    tipologiaPaziente: null,
                    provenienzaRichiesta: null,
                    strutturaProvenienza: null,
                    codiceStrutturaProvenienzaReparto: null,
                },
                accettazioneStati: [],
                accettazionePrestazioni: [],
                accettazioniAsl: { aslDomicilioAmbito: null, aslResidenzaAmbito: null },
            },
            sessoOptions: [
                { value: null, text: "-Selezionare Sesso-" },
                { value: "M", text: "Maschio" },
                { value: "F", text: "Femmina" },
            ],
            decretoInvaliditaOptions: [
                { value: null, text: "- SI / NO -" },
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            nonAutonomoOptions: [
                { value: null, text: "- SI / NO -" },
                { value: "SI", text: "Si" },
                { value: "NO", text: "No" },
            ],
            titoloStudioOptions: [],
            settingLivelliOptions: [{ id: null, descrizione: "- Seleziona Valore -" }],
        };
    },
    computed: {
        // isTabDisabled() {
        //   let me = this;
        //   console.log(me.id);
        //   return me.id === "-1";
        // },
    },
    mounted: function () {
        let me = this;
        me.anagraficaRicerca = this.appConfig.anagraficaRicerca;
        me.id = this.$route.params.id ? this.$route.params.id : this.$router.query.idAccettazione;
        me.loadStrutture();
        me.loadRegimi();
        me.loadProvinceNascita();
        me.loadRegioni();
        me.loadIdentificativi();
        me.loadTipoDocumento();
        me.loadTitoliStudio();
        me.loadStruttureProvienza();
        me.loadTipologiaPaziente();
        me.loadProvenienzaPaziente();
        me.loadProvenienzaRichiesta();
        //  me.loadDataSettingLivelliAccettazione();

        // me.loadSettingsPresidi();
        // me.loadProvince();
    },
    watch: {
        isDomicilioUgualeResidenza() {
            let me = this;
            me.setDomicilio();
        },
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
            immediate: true
        },
        // id() {
        //     let me = this;
        //     me.loadData();
        // },
    },
    methods: {
        setDomicilio() {
            let me = this;
            if (me.isDomicilioUgualeResidenza) {
                me.jsonData.accettazioneAnagrafica.regioneDomicilio = me.jsonData.accettazioneAnagrafica.regioneResidenza;
                me.jsonData.accettazioneAnagrafica.provinciaDomicilio = me.jsonData.accettazioneAnagrafica.provinciaResidenza;
                me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat = me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat;
                me.jsonData.accettazioneAnagrafica.capDomicilio = me.jsonData.accettazioneAnagrafica.capResidenza;
                me.jsonData.accettazioneAnagrafica.indirizzoDomicilio = me.jsonData.accettazioneAnagrafica.indirizzoResidenza;
            }
        },
        setJsonData(jsonData) {
            this.jsonData = jsonData
        },
        activeTab(idActiveTab) {
            let me = this;
            switch (idActiveTab) {
                case "tbDatiFatturazione":
                    me.$refs.cmpRsaAccettazioneDatiFatturazioneComponent.init(me.jsonData);
                    break;
                // case "tbSpesaExtra":
                //   me.$refs.cmpRsaSpesaExtraListComponent.loadData(me.jsonData);
                //   break;
                case "tbValutazioneIngresso":
                    me.$refs.cmpRsaPazienteValutazioneIngresso.init(me.id);
                    break;
                case "tbSpesaExtra":
                    me.$refs.cmpRsaSpesaExtraListComponent.setId(me.jsonData.id);
                    break;
                case "tbRsaImpegnativa":
                    me.$refs.cmpRsaAccettazioneImpegnativaList.loadData();
                    break;
                case "tbConsensi":
                    me.$refs.cmpRsaAccettazioneConsensiList.setDati(me.id, me.jsonData, "NURITY");
                    break;
                case "tbRsaSchedaPaziente":
                    me.$refs.cmpRsaSchedaPazienteEdit.init(me.jsonData);
                    break;
                case "tbRsaPersoneRiferimento":
                    me.$refs.RsaPersonaRiferimentoComponent.init(me.id);
                    break;
            }
            this.$emit("onActiveTab", idActiveTab);
        },

        loadData() {
            let me = this;
            // me.$emit("beforeLoadData");
            if (me.id === "-1" || me.id === undefined) {
                // me.$emit("afterLoadData");
                me.isTabDisabled = true;
            } else {
                me.isCheckIdentificativo = true;
                me.showModalLoading = true;
                me.isTabDisabled = false;
                let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
                axios
                    .get(link + me.id)
                    .then((response) => {
                        me.jsonData = response.data.data;
                        me.setPresidi();
                        me.loadSettingsPresidi(me.jsonData.idPresidio);
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaNascita, "nascita");
                        me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneResidenza, "residenza");
                        me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneDomicilio, "domicilio");
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaDomicilio, "residenza");
                        me.loadAmbitiAsl(me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
                        me.loadAmbitiAsl(me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat, "domicilio");
                        me.loadDistrettiAsl(me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
                        me.loadDistrettiAsl(me.jsonData.accettazioneAnagrafica.comuneDomicilioCodiceIstat, "domicilio");
                        me.loadDataSettingLivelli(me.jsonData.idSetting);
                        if (me.jsonData.accettazioneAnagrafica.strutturaProvenienza) {
                            me.onChangeStrutturaProvenienza(me.jsonData.accettazioneAnagrafica.strutturaProvenienza);
                        }

                        //me.setRegioni();
                        // if (me.jsonData.accettazioneAnagrafica.capResidenza === me.jsonData.accettazioneAnagrafica.capDomicilio) {
                        //   me.isDomicilioUgualeResidenza = true;
                        // }
                        me.$emit("afterLoadData");
                    })
                    .catch(() => { });
            }
        },
        loadStrutture() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceStrutture;
            axios
                .get(link)
                .then((response) => {
                    me.strutturaOptions = [];
                    me.rows = response.data.data.recordsNumber;
                    me.strutturaOptions = response.data.data;

                    if (me.strutturaOptions.length === 1) {
                        me.jsonData.codiceStruttura = me.strutturaOptions[0].codiceStruttura;
                        me.loadPresidi(me.strutturaOptions[0].id);
                    } else {
                        me.strutturaOptions.unshift({
                            codiceStruttura: null,
                            denominazione: "-Seleziona Struttura-",
                        });
                    }
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        initAccettazione(jsonDataAccettazione) {
            let me = this;
            me.jsonData = jsonDataAccettazione;
            me.isTabDisabled = true;
            me.loadData();
        },
        loadPresidi(value) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourcePresidi;
            me.presidiOptions = [];
            me.filtroPresidi = { idStruttura: value };
            axios
                .get(link, { params: me.filtroPresidi })
                .then((response) => {
                    me.presidiOptions = response.data.data.list;
                    if (me.presidiOptions.length === 1) {
                        me.jsonData.idPresidio = me.presidiOptions[0].id;
                        me.loadSettingsPresidi(me.jsonData.idPresidio);
                    } else {
                        //  me.jsonData.idPresidio = null;
                        me.presidiOptions.unshift({
                            id: null,
                            denominazione: "-Seleziona Presidio-",
                        });
                    }
                    this.$emit("afterLoadData");
                })
                .catch(() => {
                    this.$emit("afterLoadData");
                });
        },
        loadSettingsPresidi(id) {
            let me = this;
            let params = { idPresidio: id };
            UtilityMixin.methods.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
        },
        resultResponseSettings(response) {
            let me = this;
            me.settingsPresidiOptions = response.data.data.list;
            if (me.settingsPresidiOptions.length === 1) {
                me.jsonData.settingCodice = me.settingsPresidiOptions[0].codice;
                me.jsonData.settingDescrizione = me.settingsPresidiOptions[0].setting;
                me.onChangeSettingCodice(me.jsonData.settingCodice);
            }
        },
        resultErrorSettings(response) {
            UtilityMixin.methods.messaggeBoxError(this, response);
        },
        loadRegimi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegimi;
            axios
                .get(link)
                .then((response) => {
                    me.regimiOptions = response.data.data.list;
                    if (me.regimiOptions.length === 1) {
                        me.jsonData.regime = me.regimiOptions[0].codice;
                    }
                    me.regimiOptions.unshift({ codice: null, descrizione: "-Seleziona Regime-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadProvinceNascita() {
            let me = this;
            me.provinciaOption = [];
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios
                .get(link)
                .then((response) => {
                    me.provinceNascitaOptions = response.data.data;
                    me.provinceNascitaOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadComuni(sigla, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComuni + "/" + sigla;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((comune) => {
                        switch (destination) {
                            case "nascita":
                                me.comuniNascitaOptions.push(comune);
                                break;
                            case "residenza":
                                me.comuniResidenzaOptions.push(comune);
                                break;
                            case "domicilio":
                                me.comuniDomicilioOptions.push(comune);
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.status);
                });
        },
        loadRegioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceRegioni;
            axios
                .get(link)
                .then((response) => {
                    response.data.data.forEach((regione) => {
                        me.regioniResidenzaOptions.push(regione);
                        me.regioniDomicilioOptions.push(regione);
                    });
                    me.regioniResidenzaOptions.unshift({ codiceIstat: null, regione: "-Seleziona Regione-" });
                    me.regioniDomicilioOptions.unshift({ codiceIstat: null, regione: "-Seleziona Regione-" });
                })
                .catch((error) => {
                    console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                });
        },
        loadProvince(regione, destination) {
            let me = this;
            me.filtro = { regione: regione };
            let link = process.env.VUE_APP_PATH_API + me.pathResourceProvince;
            axios.get(link, { params: me.filtro }).then((response) => {
                response.data.data.forEach((provincia) => {
                    switch (destination) {
                        case "residenza":
                            me.provinceResidenzaOptions.push(provincia);
                            break;
                        case "domicilio":
                            me.provinceDomicilioOptions.push(provincia);
                            break;
                    }
                });
                if (me.id !== "-1") {
                    me.setRegioni();
                }
            });
        },
        loadCap(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceComune + "/" + codiceIstat;
            if (codiceIstat) {
                axios
                    .get(link)
                    .then((response) => {
                        switch (destination) {
                            case "residenza":
                                me.jsonData.accettazioneAnagrafica.capResidenza = response.data.data.cap;
                                break;
                            case "domicilio":
                                me.jsonData.accettazioneAnagrafica.capDomicilio = response.data.data.cap;
                                break;
                        }
                    })
                    .catch((error) => {
                        console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                    });
            }
        },
        loadAsl(codiceIstat, destination) {
            let me = this;

            let link = process.env.VUE_APP_PATH_API + me.pathResourceAsl;
            let params = { istatComune: codiceIstat };
            if (codiceIstat) {
                axios
                    .get(link, { params: params })
                    .then((response) => {
                        if (response.data.data !== null) {
                            switch (destination) {
                                case "residenza":
                                    me.jsonData.accettazioniAsl.aslResidenzaCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    me.jsonData.accettazioniAsl.aslResidenzaDenominazione = response.data.data.denominazione;
                                    break;
                                case "domicilio":
                                    me.jsonData.accettazioniAsl.aslDomicilioCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                                    me.jsonData.accettazioniAsl.aslDomicilioDenominazione = response.data.data.denominazione;
                                    break;
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error);

                        console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
                    });
            }
        },
        loadIdentificativi() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceIdentificativo;
            me.tipiIdentificativoOptions = [];
            axios
                .get(link)
                .then((response) => {
                    me.tipiIdentificativoOptions = response.data.data;
                    me.tipiIdentificativoOptions.unshift({ codice: null, descrizione: "-Seleziona Tipo Identificativo-" });
                    me.jsonData.accettazioneAnagrafica.tipoIdentificativo = "CF";
                })
                .catch((error) => {
                    console.log("Il servizio dei tipi identificativo ha datao errore: " + error.response.status);
                });
        },
        onChangeStruttura(value) {
            let me = this;
            me.strutturaOptions.forEach((element) => {
                if (element.codiceStruttura === value) {
                    me.loadPresidi(element.id);
                }
            });
        },
        onChangePresidio(value) {
            let me = this;
            me.loadSettingsPresidi(value);
            //me.presidiOptions.forEach((element) => {
            //   if (element.id === value) {
            //   }
            // });
        },
        onChangeSettingCodice(value) {
            let me = this;
            me.settingsPresidiOptions.forEach((element) => {
                if (element.codice === value) {
                    me.jsonData.settingDescrizione = element.setting;
                    me.jsonData.idSetting = element.idRsaSettings;
                    me.loadDataSettingLivelli(element.idRsaSettings);
                }
            });
        },
        onChangeProvinciaNascita(value) {
            let me = this;
            me.comuniNascitaOptions = [];
            me.comuniNascitaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(value, "nascita");
        },
        onChangeComuneNascita() { },
        onChangeRegioneResidenza(regione) {
            let me = this;
            me.jsonData.accettazioneAnagrafica.provinciaResidenza = null;
            me.provinceResidenzaOptions = [];
            me.provinceResidenzaOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
            me.loadProvince(regione, "residenza");
            me.setDomicilio();
        },
        onChangeProvinciaResidenza(provincia) {
            let me = this;
            me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat = null;
            me.comuniResidenzaOptions = [];
            me.comuniResidenzaOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(provincia, "residenza");
            me.setDomicilio();
        },
        onChangeComuneResidenza(value) {
            let me = this;
            me.loadCap(value, "residenza");
            me.loadAsl(value, "residenza");
            me.loadDistrettiAsl(value, "residenza");
            me.loadAmbitiAsl(value, "residenza");
            me.setDomicilio();
        },
        onInputRegioniDomicilio(regione) {
            let me = this;
            me.provinceDomicilioOptions = [];
            me.provinceDomicilioOptions.unshift({ sigla: null, provincia: "-Seleziona Provincia-" });
            me.loadProvince(regione, "domicilio");
        },
        onInputProvinciaDomicilio(provincia) {
            let me = this;
            me.comuniDomicilioOptions = [];
            me.comuniDomicilioOptions.unshift({ codiceIstat: null, comune: "-Seleziona Comune-" });
            me.loadComuni(provincia, "domicilio");
        },
        onInputComuneDomicilio(value) {
            let me = this;
            me.loadCap(value, "domicilio");
            me.loadAsl(value, "domicilio");
            me.loadDistrettiAsl(value, "domicilio");
            me.loadAmbitiAsl(value, "domicilio");
        },
        onInputCapResidenza() {
            let me = this;
            me.setDomicilio();
        },
        onInputIndirizzoResidenza() {
            let me = this;
            me.setDomicilio();
        },
        onInputTabs(index) {
            let me = this;
            let activeTab = this.$refs.tabsRsaAccettazioneEdit.getTabs()[index];
            me.activeTab(activeTab.id);
        },

        onNuovaPersonaRiferimento() {
            let me = this;
            me.$refs.RsaPersonaRiferimentoComponent.onNuovaPersonaRiferimento();
        },
        loadDataPersoneRiferimento() {
            let me = this;
            me.$refs.RsaPersonaRiferimentoComponent.loadData();
        },
        loadDataSchedeValutazione() {
            let me = this;
            me.$refs.RsaAccettazioneSchedeValutazioneComponent.init(me.jsonData.id);
        },
        loadDataRicette() {
            let me = this;
            me.$refs.RsaAccettazioneRicetteListComponent.loadData();
        },
        setDatiFatturazione() {
            let me = this;
            me.$refs.RsaAccettazioneDatiFatturazioneComponent.setData();
        },
        // setDataImpegnativa() {
        //   let me = this;
        //   me.$refs.RsaAccettazioneImpegnativaListComponent.setData();
        // },
        onNuovaRicetta() {
            let me = this;
            me.$refs.RsaAccettazioneRicetteListComponent.nuovaRicetta();
        },
        onNuoviDatiFatturazione() {
            let me = this;
            me.$refs.cmpRsaAccettazioneDatiFatturazioneComponent.nuoviDatiFatturazione();
        },
        onNuovaImpegnativa() {
            let me = this;
            me.$refs.cmpRsaAccettazioneImpegnativaList.nuovaImpegnativa();
        },
        onNuovoAllegatoA() {
            let me = this;
            me.$refs.cmpRsaAccettazioneSchedaValutazioneAllegatoAComponent.salvaAllegato();
        },
        onKeyPress(e) {
            let me = this;
            if (e.keyCode === 13) {
                me.searchAnagrafica();
            }
        },
        onSearchAnagraficaClick() {
            let me = this;
            me.searchAnagrafica();
        },
        searchAnagrafica() {
            let me = this;
            me.showmolalloading = true;
            if (me.jsonData.accettazioneAnagrafica.identificativo.trim().length === 0) {
                me.showmolalloading = false;
            } else {
                me.jsonData.accettazioneAnagrafica.identificativo = me.jsonData.accettazioneAnagrafica.identificativo.toUpperCase();
                let link = process.env.VUE_APP_PATH_API + "/utility";
                axios
                    .get(link, {
                        params: { codiceFiscale: me.jsonData.accettazioneAnagrafica.identificativo },
                    })
                    .then((response) => {
                        me.jsonData.accettazioneAnagrafica.nome = response.data.data.nome;
                        me.jsonData.accettazioneAnagrafica.cognome = response.data.data.cognome;
                        me.jsonData.accettazioneAnagrafica.dataNascita = moment(response.data.data.dataNascita, "DD/MM/YYYY").toDate().getTime();
                        me.jsonData.accettazioneAnagrafica.sesso = response.data.data.sesso;
                        me.jsonData.accettazioneAnagrafica.provinciaNascita = response.data.data.provinciaNascita;
                        me.jsonData.accettazioneAnagrafica.regioneResidenza = response.data.data.regioneResidenza;
                        me.jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat = response.data.data.codiceIstatComuneNascita;
                        me.jsonData.accettazioneAnagrafica.provinciaResidenza = response.data.data.provinciaResidenza;
                        me.jsonData.accettazioneAnagrafica.comuneResidenzaCodiceIstat = response.data.data.codiceIstatComuneResidenza;
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaNascita, "nascita");
                        me.loadProvince(me.jsonData.accettazioneAnagrafica.regioneResidenza, "residenza");
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaResidenza, "residenza");
                        me.loadCap(response.data.data.codiceIstatComuneResidenza, "residenza");
                        me.loadAsl(response.data.data.codiceIstatComuneResidenza, "residenza");
                        me.setDomicilio();
                        me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaDomicilio, "domicilio");
                        me.jsonData.accettazioneAnagrafica.indirizzoResidenza = response.data.data.indirizzoResidenza;
                        me.jsonData.accettazioneAnagrafica.codiceFiscaleMedicoCurante = response.data.data.codiceFiscaleMedico;
                        me.jsonData.accettazioneAnagrafica.medicoCurante = response.data.data.medico;

                        me.showmolalloading = false;
                    })
                    .catch(() => {
                        me.showmolalloading = false;
                    });
            }
        },
        setRegioni() {
            let me = this;
            me.provinceResidenzaOptions.forEach((element) => {
                if (element.sigla === me.jsonData.accettazioneAnagrafica.provinciaResidenza) {
                    if (me.jsonData.accettazioneAnagrafica.regioneResidenza === null || me.jsonData.accettazioneAnagrafica.regioneResidenza === "") {
                        me.jsonData.accettazioneAnagrafica.regioneResidenza = element.regione;
                    }
                }
                if (element.sigla === me.jsonData.accettazioneAnagrafica.provinciaDomicilio) {
                    if (me.jsonData.accettazioneAnagrafica.regioneDomicilio === null || me.jsonData.accettazioneAnagrafica.regioneDomicilio === "") {
                        me.jsonData.accettazioneAnagrafica.regioneDomicilio = element.regione;
                    }
                }
            });
        },
        setPresidi() {
            let me = this;
            me.strutturaOptions.forEach((element) => {
                if (element.codiceStruttura === me.jsonData.codiceStruttura) {
                    me.loadPresidi(element.id);
                }
            });
        },

        loadTitoliStudio() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTitoliStudio, {}, me.resultResponseTitoliStudio, me.resultErrorTitoliStudio);
        },
        resultResponseTitoliStudio(response) {
            let me = this;
            me.titoloStudioOptions = response.data.data.list;
            me.titoloStudioOptions.unshift({ codice: null, descrizione: "- Seleziona Titolo di Studio -" });
        },
        resultErrorTitoliStudio(error) {
            console.log(error);
        },
        loadStruttureProvienza() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceStruttureProvienza, {}, me.resultResponseStruttureProvenienza, me.resultErrorStruttureProvenienza);
        },
        resultResponseStruttureProvenienza(response) {
            let me = this;
            me.strutturaProvenienzaOptions = response.data.data.list;
            me.strutturaProvenienzaOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        resultErrorStruttureProvenienza(error) {
            console.log(error);
        },
        loadTipologiaPaziente() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceTipologiaPaziente, {}, me.resultResponseTipologiaPaziente, me.resultErrorTipologiaPaziente);
        },
        resultResponseTipologiaPaziente(response) {
            let me = this;
            me.tipologiaPazienteOptions = response.data.data.list;
            me.tipologiaPazienteOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        resultErrorTipologiaPaziente(error) {
            console.log(error);
        },
        loadProvenienzaPaziente() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceProvenienzaPaziente, {}, me.resultResponseProvenienzaPaziente, me.resultErrorProvenienzaPaziente);
        },
        resultResponseProvenienzaPaziente(response) {
            let me = this;
            me.provenienzaPazienteOptions = response.data.data.list;
            me.provenienzaPazienteOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        resultErrorProvenienzaPaziente(error) {
            console.log(error);
        },
        loadTipoDocumento() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceIdentificativo;
            me.tipiIdentificativoOptions = [];
            axios
                .get(link)
                .then((response) => {
                    me.tipoDocumentoOptions = response.data.data;
                    me.tipoDocumentoOptions.unshift({ codice: null, descrizione: "-Seleziona Tipo Documento-" });
                })
                .catch((error) => {
                    console.log("Il servizio identificativi ha datao errore: " + error.response.status);
                });
        },
        onClickCodiceFiscale(value) {
            let me = this;
            if (value) {
                var regexCodiceFiscale = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
                if (regexCodiceFiscale.test(value.toUpperCase())) {
                    this.codiceFiscaleValido = true;
                } else {
                    this.codiceFiscaleValido = false;
                }
                const codice = value;
                me.jsonData.accettazioneAnagrafica.identificativo = codice;
                me.checkCodiceFiscale(me.jsonData.accettazioneAnagrafica.identificativo.toUpperCase());
            } else {
                me.$bvToast.toast("Inserire Codice Fiscale", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        checkCodiceFiscale(codiceFiscale) {
            let me = this;
            if (me.codiceFiscaleValido) {
                let path = "/utilityanagrafica/codicefiscale";
                me.loadDataResources(path, { codiceFiscale: codiceFiscale }, me.resultResponseCodiceFiscale, me.resultErrorCodiceFiscale);
            } else {
                me.$bvToast.toast("Codice Fiscale non corretto", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        resultResponseCodiceFiscale(response) {
            let me = this;

            me.anagraficaInfo = response.data.data;
            me.jsonData.accettazioneAnagrafica.dataNascita = me.anagraficaInfo.dataNascita;
            me.jsonData.accettazioneAnagrafica.sesso = me.anagraficaInfo.sesso;
            me.jsonData.accettazioneAnagrafica.comuneNascitaCodiceIstat = me.anagraficaInfo.comuneNascitaCodiceIstat;
            me.jsonData.accettazioneAnagrafica.provinciaNascita = me.anagraficaInfo.provinciaNascita;
            me.loadComuni(me.jsonData.accettazioneAnagrafica.provinciaNascita, "nascita");
        },
        resultErrorCodiceFiscale(error) {
            let me = this;
            let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "";
            me.$bvToast.toast("Errore durante il caricamento: " + messaggio, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onClickSearchIcdix() {
            let me = this;
            me.$refs.cmpDiagnosiIcdIx.onClickBtnRicercaIcdIx();
        },
        modalClose(data) {
            let me = this;
            let diagnosi = data[0];
            me.$set(me.jsonData, "diagnosiIngresso", "(" + diagnosi[0].codiceIcdix + ") " + diagnosi[0].descrizioneIcdix);
        },
        loadDistrettiAsl(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDistretti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    //      response.data.data.list.forEach((element) => {
                    switch (destination) {
                        case "residenza":
                            me.distrettiAslResidenzaOptions = [];
                            //me.distrettiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                            me.distrettiAslResidenzaOptions = response.data.data.list;
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazioniAsl.aslResidenzaDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            me.distrettiAslResidenzaOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
                            break;
                        case "domicilio":
                            me.distrettiAslDomicilioOptions = [];
                            me.distrettiAslDomicilioOptions = response.data.data.list; //.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                            if (response.data.data.list.length === 1) {
                                me.jsonData.accettazioniAsl.aslDomicilioDistretto = response.data.data.list[0].codiceDistretto;
                            }
                            me.distrettiAslDomicilioOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
                            break;
                    }
                    //  });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
        loadAmbitiAsl(codiceIstat, destination) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbiti;
            let params = { comuneCodiceIstat: codiceIstat };
            axios
                .get(link, { params: params })
                .then((response) => {
                    response.data.data.list.forEach((element) => {
                        switch (destination) {
                            case "residenza":
                                me.ambitiAslResidenzaOptions = [];
                                me.ambitiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                                if (response.data.data.list.length === 1) {
                                    me.jsonData.accettazioniAsl.aslResidenzaAmbito = response.data.data.list[0].codiceAmbito;
                                }
                                me.ambitiAslResidenzaOptions.unshift({ text: "- Seleziona Valore -", value: null });
                                break;
                            case "domicilio":
                                me.ambitiAslDomicilioOptions = [];
                                me.ambitiAslDomicilioOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                                if (response.data.data.list.length === 1) {
                                    me.jsonData.accettazioniAsl.aslDomicilioAmbito = response.data.data.list[0].codiceAmbito;
                                }
                                me.ambitiAslDomicilioOptions.unshift({ text: "- Seleziona Valore -", value: null });
                                break;
                        }
                    });
                })
                .catch((error) => {
                    console.log("Il servizio delle province ha datao errore: " + error.response.data);
                });
        },
        salvaSchedaPaziente() {
            let me = this;
            me.$refs.cmpRsaSchedaPazienteEdit.salva();
        },
        loadDataSettingLivelli(idSetting) {
            let me = this;
            if (idSetting) {
                me.loadDataResources(me.pathResourceRsaSettingLivelli, { idSetting: idSetting }, me.resultResponseSettingLivelli, null);
            }
        },
        resultResponseSettingLivelli(response) {
            let me = this;
            me.settingLivelliOptions = [];
            me.settingLivelliOptions = response.data.data.list;
            me.settingLivelliOptions.unshift({ descrizione: "- Seleziona Valore -", id: null });
        },
        onChangeRsaSettingLivelli(value) {
            let me = this;
            me.settingLivelliOptions.forEach((element) => {
                if (element.id === value) {
                    me.jsonData.descrizioneLivello = element.descrizione;
                }
            });
        },
        loadProvenienzaRichiesta() {
            let me = this;
            me.loadDataResources(me.pathResourceProvenienzaRichiesta, {}, me.resultResponseProvenienzaRichiesta, null);
        },
        resultResponseProvenienzaRichiesta(response) {
            let me = this;
            me.provenienzaRichiestaOptions = [];
            me.provenienzaRichiestaOptions = response.data.data.list;
            me.provenienzaRichiestaOptions.unshift({ codice: null, descrizione: "- Seleziona Valore -" });
        },
        onChangeProvenienzaRichiesta(value) {
            let me = this;
            me.isProvienzaRichiestaDisable = value === "ROC" || value === "DIMISSIONI PROTETTE";
        },
        onChangeStrutturaProvenienza(value) {
            let me = this;
            let strutturaProvenienza = me.strutturaProvenienzaOptions.find((element) => element.codice === value);
            if (strutturaProvenienza) {
                me.loadStrutturaProvenienzaReparti(strutturaProvenienza.id);
            }
        },
        loadStrutturaProvenienzaReparti(value) {
            let me = this;
            let filtro = { idRsaStrutturaProvenienza: value };
            me.loadDataResources(me.pathResourceStrutturaProvenienzaReparti, filtro, me.resultResponseStrutturaProvenienzaReparti, null);
        },
        resultResponseStrutturaProvenienzaReparti(response) {
            let me = this;
            me.strutturaProvenienzaRepartiOptions = [];
            me.strutturaProvenienzaRepartiOptions = response.data.data.list;
            me.strutturaProvenienzaRepartiOptions.unshift({ codiceReparto: null, descrizioneReparto: "- Seleziona Valore -" });
        },
        onChangeStrutturaProvenienzaReparto(value) {
            let me = this;
            let reparto = me.strutturaProvenienzaRepartiOptions.find((element) => element.codiceReparto === value);
            if (reparto) {
                me.jsonData.accettazioneAnagrafica.denominazioneStrutturaProvenienzaReparto = reparto.descrizioneReparto;
            }
        },
    },
};
</script>
<style scoped>
.sa-tab-scrol {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 5px 10px 35px 10px;
}
</style>
